import { FetchError } from '../errors/FetchError'
import { fetchApiImageAuth3, fetchFileWithAuthorization, fetchWithAuthorization } from './fetch'

export const createProvider = async (condominiumId, payload) => {
  try {
    const data = await fetchWithAuthorization('/provider', { condominium: condominiumId, ...payload }, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create bank failed')
  }
}

export const updateProvider = async (provider, payload) => {
  try {
    const data = await fetchWithAuthorization(`/provider/${provider}`, payload, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create bank failed')
  }
}

export const deleteProvider = async (provider) => {
  try {
    const data = await fetchWithAuthorization(`/provider/${provider}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create bank failed')
  }
}

export const fetchProviders = async (page, limit = 10, params) => {
  const { condominiumId, search } = params

  try {
    /*         let url = `/provider/search/all?page=${page}&limit=${limit}&condominium_id=${condominiumId}`; */

    /* let url = `/provider?condominium=${condominiumId}&page=${page}&limit=${limit}`; */

    let url = `/provider?condominium=${condominiumId}&page=${page}&limit=${limit}`

    if (search) url += `&search=${encodeURIComponent(search)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in FetchProviders')
  }
}

export const fetchCondominiumProvider = async (page, limit = 10, params) => {
  const { condominiumId, search } = params
  try {
    let url = `/provider/search/all?page=${page}&limit=${limit}&condominium_id=${condominiumId}`
    if (search) url += `&search=${encodeURIComponent(search)}`
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in FetchBanks')
  }
}

export const fetchProvidersAsProperty = async (page, limit = 10, params) => {
  const { search } = params

  try {
    let url = `/provider/show/all?page=${page}&limit=${limit}`

    if (search) url += `&search=${encodeURIComponent(search)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in FetchBanks')
  }
}

export const getProvider = async (provider) => {
  try {
    const data = await fetchWithAuthorization(`/provider/${provider}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create bank failed')
  }
}

export const exportProvidersToExcel = async (condominiumId, format) => {
  try {
    const query = format ? `?format=${encodeURIComponent(format)}` : ''

    return await fetchFileWithAuthorization(`/provider/export/${condominiumId}${query}`)
  } catch (error) {
    throw new FetchError(error, 'Error al exportar proveedores')
  }
}

export const importProvidersFromExcel = async (condominiumId, file) => {
  try {
    return await fetchApiImageAuth3(`/provider/import/${condominiumId}`, file, 'POST', true)
  } catch (error) {
    throw new FetchError(error, 'Error al importar proveedores')
  }
}
